<template>
  <h2 class="enumeration-with-arrow smokeheadlineh2 enumerationHeadlineH2">
    <div class="d-none d-sm-block">
      <div class="col-md-8 offset-1 padding-0">
        <div class="row flexFont">
          <div class="col-3 text-left">{{ $t(enumerationStrings[0]) }}</div>
          <div class="col-3 text-center">{{ $t(enumerationStrings[1]) }}</div>
          <div class="col-6 text-left">{{ $t(enumerationStrings[2]) }}</div>
        </div>
      </div>
      <div class="row">
        <div class=" col-md-8 offset-1 text-left">
          <button class="enumerationButton" id="link2" @click="onClickFunction">
            <img
              src="@/assets/images/arrow_yellow.png"
              class="img-responsive enumerationButtonImage"
            />
          </button>
        </div>
      </div>
    </div>
    <div class="d-block d-sm-none ">
      <div class="col-12">{{ $t(enumerationStrings[0]) }}</div>
      <div class="col-12">{{ $t(enumerationStrings[1]) }}</div>
      <div class="col-12">{{ $t(enumerationStrings[2]) }}</div>
      <div id="magic"></div>
      <div class="col-12">
        <button class="enumerationButton" id="link2" @click="onClickFunction">
          <img
            src="@/assets/images/arrow_yellow.png"
            class="img-responsive enumerationButtonImage"
          />
        </button>
      </div>
    </div>
  </h2>
</template>

<script>
export default {
  name: "EnumerationWithArrow",
  props: {
    enumerationStrings: Array,
    arrowFunction: Function,
    scrollToArgument: String
  },
  created() {
    window.addEventListener("resize", this.flexFont);
  },
  mounted() {
    this.flexFont();
  },
  destroyed() {
    window.removeEventListener("resize", this.flexFont);
  },
  methods: {
    onClickFunction() {
      var isSliderActive = this.arrowFunction();
      isSliderActive ? this.scrollTo() : null;
    },
    scrollTo() {
      document.getElementById(this.scrollToArgument).scrollIntoView({
        behavior: "smooth"
      });
    },
    flexFont() {
      var divs = document.getElementsByClassName("flexFont");
      for (var i = 0; i < divs.length; i++) {
        var relFontsize = divs[i].offsetWidth * 0.05;
        divs[i].style.fontSize = relFontsize + "px";
      }
    }
  }
};
</script>

<style scoped>
.enumeration-with-arrow {
  overflow: hidden;
}
.enumerationButton {
  background-color: transparent;
  border: 0;
  margin-top: 20px;
  margin-bottom: 3px;
  padding-left: 0;
}

.enumerationButtonImage {
  max-width: 90px;
}

.enumerationHeadlineH2 {
  color: #d6df23;
  opacity: 0.6;
  margin-bottom: 0;
}
</style>
